import React, { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged
} from "firebase/auth";
// import "../styles/login.css";

// Firebase config from fb.json
const firebaseConfig = require("../fb.json");

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const redirectTo =
      new URLSearchParams(window.location.search).get("redirect") || "/";
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdToken();
        document.cookie = `__session=${JSON.stringify({
          authToken: token
        })}; Path=/; Secure; SameSite=Strict`;

        if (window.location.pathname === "/login") {
          window.location.href = redirectTo;
        }
      }
    });

    // Ensure MDL text fields are upgraded
    if (window.componentHandler) {
      window.componentHandler.upgradeDom();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const token = await userCredential.user.getIdToken();

      document.cookie = `__session=${JSON.stringify({
        authToken: token
      })}; Path=/; Secure; SameSite=Strict`;

      alert("Logged in successfully!");
      const redirectTo =
        new URLSearchParams(window.location.search).get("redirect") || "/";
      window.location.href = redirectTo;
    } catch (error) {
      console.error("Login error:", error);
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="mdl-card mdl-shadow--2dp login-card">
        <h4 className="login-title">Login</h4>
        <form onSubmit={handleSubmit}>
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input
              className="mdl-textfield__input"
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label className="mdl-textfield__label" htmlFor="email">
              Email
            </label>
          </div>
          <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input
              className="mdl-textfield__input"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label className="mdl-textfield__label" htmlFor="password">
              Password
            </label>
          </div>
          <div className="mdl-card__actions">
            <button
              className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
              type="submit">
              Login
            </button>
          </div>
        </form>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
    </div>
  );
};

export default Login;
